/**
 * Tile shown when a widget query returns zero matching rows. Distinct
 * from ErrorState so reviewers can tell a "no data this period" tile
 * from a "query failed" tile.
 */
export interface EmptyStateProps {
  title?: string;
  caption?: string;
  height?: number;
}

export default function EmptyState(props: EmptyStateProps) {
  const { title = "No data for this period", caption, height = 140 } = props;
  return (
    <div
      style={{
        background: "var(--bg-card)",
        border: "1px dashed var(--border-subtle)",
        borderRadius: 12,
        padding: "20px 22px",
        height,
        display: "grid",
        gap: 6,
        alignContent: "center",
        color: "var(--text-muted)",
      }}
    >
      <div style={{ fontSize: 12, textTransform: "uppercase", letterSpacing: 0.5 }}>{title}</div>
      {caption ? <div style={{ fontSize: 13 }}>{caption}</div> : null}
    </div>
  );
}
